const config = (window as any).config || {};

export const environment = {
  production: config.production,
  version: config.version,
  apiUrl: config.apiUrl,
  auth: {
    authOnAppInitializer: config.authOnAppInitializer,
    issuer: config.issuer,
    redirectUri: config.redirectUri,
    clientId: config.clientId,
    clientSecret: config.clientSecret,
    scope: config.scope,
    userinfoEndpoint: config.userinfoEndpoint,
    triggerUserInfoAfterLogin: config.triggerUserInfoAfterLogin,
    fallbackAccessTokenExpirationTimeInSec: config.fallbackAccessTokenExpirationTimeInSec,
    skipSubjectCheck: config.skipSubjectCheck,
    bearerAllowedUrls: config.bearerAllowedUrls,
    logoutOnBlankTab: config.logoutOnBlankTab,
    idleTimeout: config.idleTimeout
  },
  pbi: {
    datasetId: config.datasetId,
    reportId: config.reportId,
    pages: {
      measure: config.measurePageId,
      analyse: config.analysePageId,
      scenario1: config.scenario1PageId,
      scenario2: config.scenario2PageId,
      scenario3: config.scenario3PageId
    }
  },
  pbiV2: {
    datasetId: config.datasetIdV2,
    reportId: config.reportIdV2,
    pages: {
      measure: config.measurePageIdV2,
      analyse: config.analysePageIdV2,
      scenario1: config.scenario1PageId,
      scenario2: config.scenario2PageId,
      scenario3: config.scenario3PageId
    }
  },
  pbiShipper: {
    datasetId: config.shipperDatasetId,
    reportId: config.shipperReportId,
    pages: {
      measure: config.shipperMeasurePageId,
      analyse: config.shipperAnalysePageId,
      scenario1: config.scenario1PageId,
      scenario2: config.scenario2PageId,
      scenario3: config.scenario3PageId
    }
  },
  pbiDLE: {
    datasetId: config.dleDatasetId,
    reportId: config.dleReportId,
    pages: {
      measure: config.dleMeasurePageId,
      analyse: config.dleAnalysePageId,
      scenario1: config.scenario1PageId,
      scenario2: config.scenario2PageId,
      scenario3: config.scenario3PageId
    }
  },
  matomo: {
    trackerUrl: config.matomoTrackerUrl,
    siteId: config.matomoSiteId,
  }
};
